import config from './config.api';
import axiosRetry from 'axios-retry';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { axiosWithHeaders } from '@innovyze/stylovyze/lib/utils/axiosGenerator';
import { formatUrlTrailing } from '@innovyze/stylovyze/lib/utils/urlFormatting';
export const endpoint = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://aws.com/api/v2';
const apiEnv = localStorage.getItem('apiEnv') || undefined;
export const alertsManagerBaseUrl = formatUrlTrailing(getService('alertsManager', config, apiEnv));
export const alertsBaseUrl = formatUrlTrailing(getService('alertsManager', config, apiEnv));
const service = axiosWithHeaders({
    service: 'alertsManager',
    config,
    injectTenantId: false,
});
axiosRetry(service, {
    retries: 3,
    retryDelay: retryCount => {
        return retryCount * 1000;
    },
});
export default service;
